<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { useStore } from "@/state/pinia_store.js";

import {getSummaryEquity1} from '@/api/user'
/**
 * Starter component
 */
export default {
  page: {
    title: "账户概览",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  props: {
    updating: {
      type: Boolean,
    },
  },
  data() {
    return {
      // stores: useStore(),
      u_title: "资管u本位账户",
      btc_title: "资管btc本位账户",
      cta_title: "资管eth本位账户",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      coinFields: [
        {
          key: "exchange",
          label: "交易所"
        },
        {
          key: "e_count",
          label: "账户数"
        },
        {
          key: "aum",
          label: "总规模"
        },
        {
          key: "aum_m",
          label: "总规模USDT(M)"
        },
        {
          key: "apr7",
          label: "七日年化(%)"
        },
        {
          key: "apr30",
          label: "30日年化(%)"
        },
        {
          key: "apr90",
          label: "90日年化(%)"
        },
      ],
      
      u_Aum: 0,
      u_Aum_m: 0,
      u_StrategyCount: 0,
      u_TotalProfit: 0,
      u_7Ret: 0,
      u_30Ret: 0,
      u_90Ret: 0,
      u_data: [],


      btc_Aum: 0,
      btc_Aum_m: 0,
      btc_StrategyCount: 0,
      btc_TotalProfit: 0,
      btc_7Ret: 0,
      btc_30Ret: 0,
      btc_90Ret: 0,
      btc_data: [],

      eth_Aum: 0,
      eth_Aum_m: 0,
      eth_StrategyCount: 0,
      eth_TotalProfit: 0,
      eth_7Ret: 0,
      eth_30Ret: 0,
      eth_90Ret: 0,
      eth_data: [],

      res: {},

    };
  },
  methods: {
    showEquitySummary() {
      getSummaryEquity1().then((res) => {
      this.res = res
      let u_res = res["USDT"]
      let btc_res = res["BTC"]
      let eth_res = res["ETH"]

      //u_client
      this.u_Aum = u_res["total_aum"]
      this.u_Aum_m = u_res["total_aum_m"]
      this.u_StrategyCount = u_res["total_count"]
      this.u_TotalProfit = u_res["total_profit"]
      this.u_7Ret = u_res["total_apr7"]
      this.u_30Ret = u_res["total_apr30"]
      this.u_90Ret = u_res["total_apr90"]
      this.u_data = u_res["details"]



      //btc_client
      this.btc_Aum = btc_res["total_aum"]
      this.btc_Aum_m = btc_res["total_aum_m"]
      this.btc_StrategyCount = btc_res["total_count"]
      this.btc_TotalProfit = btc_res["total_profit"]
      this.btc_7Ret = btc_res["total_apr7"]
      this.btc_30Ret = btc_res["total_apr30"]
      this.btc_90Ret = btc_res["total_apr90"]
      this.btc_data = btc_res["details"]


      //cta_client
      this.eth_Aum = eth_res["total_aum"]
      this.eth_Aum_m = eth_res["total_aum_m"]
      this.eth_StrategyCount = eth_res["total_count"]
      this.eth_TotalProfit = eth_res["total_profit"]
      this.eth_7Ret = eth_res["total_apr7"]
      this.eth_30Ret = eth_res["total_apr30"]
      this.eth_90Ret = eth_res["total_apr90"]
      this.eth_data = eth_res["details"]


      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    // console.log("hh")
    this.showEquitySummary()
  },
  destroyed(){
  },
  beforeDestroy(){
  }
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="u_title"
    />

    <div class="row">
      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                AUM
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                $ {{u_Aum}}
                <!-- <i v-if="Aum >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                账户数
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{u_StrategyCount}}
                <!-- <i v-if="YearProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="YearProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span class="ml-2 text-truncate">30日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-purchase-tag-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                累计收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                $ {{u_TotalProfit}}
                <!-- <i v-if="TotalProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>

              <!-- <div class="d-flex">
                <span v-if="TotalProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span class="ml-2 text-truncate">年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                7日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{u_7Ret}} %
                <i v-if="u_7Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                30日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{u_30Ret}} %
                <i v-if="u_30Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                90日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{u_90Ret}} %
                <i v-if="u_90Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>


    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              明细
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="u_data"
                  :fields="coinFields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>
  

    <PageHeader
      :title="btc_title"
    />

    <div class="row">
      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                AUM
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                {{btc_Aum}} BTC  ${{btc_Aum_m}} M
                <!-- <i v-if="Aum >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                账户数
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{btc_StrategyCount}}
                <!-- <i v-if="YearProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="YearProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span class="ml-2 text-truncate">30日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-purchase-tag-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                累计收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                {{btc_TotalProfit}} BTC
                <!-- <i v-if="TotalProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>

              <!-- <div class="d-flex">
                <span v-if="TotalProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span class="ml-2 text-truncate">年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                7日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{btc_7Ret}} %
                <i v-if="btc_7Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                30日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{btc_30Ret}} %
                <i v-if="btc_30Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                90日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{btc_90Ret}} %
                <i v-if="btc_90Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>


    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              明细
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="btc_data"
                  :fields="coinFields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>
  

    <PageHeader
      :title="eth_title"
    />

    <div class="row">
      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                AUM
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                {{eth_Aum}} ETH ${{eth_Aum_m}} M
                <!-- <i v-if="Aum >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                账户数
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{eth_StrategyCount}}
                <!-- <i v-if="YearProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="YearProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span class="ml-2 text-truncate">30日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-purchase-tag-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                累计收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                {{eth_TotalProfit}} ETH
                <!-- <i v-if="TotalProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>

              <!-- <div class="d-flex">
                <span v-if="TotalProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span class="ml-2 text-truncate">年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                7日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{eth_7Ret}} %
                <i v-if="eth_7Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                30日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{eth_30Ret}} %
                <i v-if="eth_30Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                90日年化收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                 {{eth_90Ret}} %
                <i v-if="eth_90Ret >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>


    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              明细
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="eth_data"
                  :fields="coinFields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>